import { createWebHistory, createRouter } from "vue-router";
import { useGlobalStore } from "@stores/global";

/* Layouts */
import App from "@layouts/App.vue";

/* Pages */
import Index from "@pages/Index.vue";

/* Routes */
const routes = [
    {
        path: "/",
        component: App,
        children: [
            { path: "", name: "index", component: Index },
            {
                path: "/:catchAll(.*)",
                name: "404",
                redirect: { name: "index" },
            },
        ],
    },
];

const router = createRouter({
    scrollBehavior(to, from, savedPosition) {
        if (to.name == from.name && !to.hash) {
            return { top: 0, behavior: "smooth" };
        } else if (to.hash) {
            return {
                el: to.hash,
                top: 100,
                behavior: "smooth",
            };
        } else {
            return {
                top: 0,
            };
        }
    },
    history: createWebHistory(),
    routes,
});

// router.beforeEach((to, from, next) => {
//     const global = useGlobalStore();
//     global.closeModal();
//     next();
// });

export default router;
